import {createFeature, StoreModule} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import {currentSupervisionReducer} from './reducer/current-supervision.reducer';
import {withSessionStoragePersistence} from "../../../redux/reducer-utils/with-session-storage-persistence";


export const currentSupervisionStoreConfig = StoreModule.forFeature(
    createFeature({
        name: StoreKeys.CURRENT_SUPERVISION,
        reducer: withSessionStoragePersistence(StoreKeys.CURRENT_SUPERVISION, currentSupervisionReducer)
    }))
;
